import React, { useState, useEffect, useRef, useCallback } from 'react';
import './MobileStepProcess.css';

// Statische Daten außerhalb der Komponente
const MOBILE_STEPS_DATA = [
  {
    title: "15 Minute Strategy Call",
    description: "Schedule a personal consultation where we discuss your catalog goals, current challenges, and identify the most promising revenue opportunities for your music.",
    icon: "video.svg"
  },
  {
    title: "Catalog Deep Dive", 
    description: "Our team manually connects to your streaming accounts and thoroughly reviews your catalog to identify revenue gaps, distribution issues, and optimization opportunities across all markets.",
    icon: "flasher.svg"
  },
  {
    title: "Finished PDF Analysis Delivery",
    description: "Receive your comprehensive Song Audit report with actionable insights, revenue recovery roadmap, and step-by-step implementation guide delivered directly to your inbox.",
    icon: "signature.svg"
  },
  {
    title: "Start Earning More Streaming Revenue",
    description: "Implement our recommendations to unlock hidden revenue streams, fix distribution gaps, and maximize your catalog's earning potential across all streaming platforms.",
    icon: "receive-money.svg"
  }
];

const MobileStepProcess = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const containerRef = useRef(null);
  const rafRef = useRef(null);

  // Throttled scroll handler mit requestAnimationFrame
  const handleScroll = useCallback(() => {
    if (rafRef.current) {
      cancelAnimationFrame(rafRef.current);
    }
    
    rafRef.current = requestAnimationFrame(() => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const containerHeight = containerRef.current.offsetHeight;
        const windowHeight = window.innerHeight;
        
        const scrollTop = Math.max(0, -rect.top);
        const scrollHeight = containerHeight - windowHeight;
        
        let progress = scrollHeight > 0 ? scrollTop / scrollHeight : 0;
        progress = Math.max(0, Math.min(1, progress));
        
        setScrollProgress(progress);
      }
    });
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, [handleScroll]);

  return (
    <div ref={containerRef} className="mobile-step-process-container">
      <div className="mobile-step-process-content">
        
        {/* Leuchtbar im Hintergrund */}
        <div className="mobile-progress-bar-container">
          <div 
            className="mobile-progress-bar"
            style={{
              height: `${scrollProgress * 100}%`,
              willChange: 'height'
            }}
          />
        </div>
        
        {/* Header */}
        <div className="mobile-step-process-header">
          <h2 className="mobile-step-process-title">Our Explosive Revenue Transformation Process</h2>
          <p className="mobile-step-process-subtitle">
            From discovery call to revenue explosion - discover how our elite team transforms your music catalog into a profit-generating powerhouse with guaranteed results.
          </p>
        </div>

        {/* Steps Container */}
        <div className="mobile-steps-container">
          {MOBILE_STEPS_DATA.map((step, index) => (
            <div key={step.icon} className="mobile-step-item">
              {/* Step Icon */}
              <div className="mobile-step-icon">
                <img 
                  src={`/img/${step.icon}`} 
                  alt={`Step ${index + 1} Icon`}
                  loading="lazy"
                  decoding="async"
                  width="32"
                  height="32"
                />
              </div>

              {/* Step Content */}
              <div className="mobile-step-text">
                <h3 className="mobile-step-title">
                  Step {index + 1}
                </h3>
                <h4 className="mobile-step-subtitle">
                  {step.title}
                </h4>
                <p className="mobile-step-description">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default MobileStepProcess; 